'use client';

import { useEffect, useState, useRef } from "react";
import cn from "clsx";
import styles from './index.module.scss';
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from '@/types/modal';
import Carousel from '@/components/molecules/CustomCarousels/Carousel';

interface SentBy {
  name: string;
  avatar?: string;
  title?: string;
}


export const TestimonialText = ({ text, sent_by, rating, Id }: { text: string, sent_by: SentBy, rating: number, Id?: string }) => {
  const [showMore, setShowMore] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const modalDispatch = useModalDispatch();

  const handleTestimonial = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.TestimonialModal,
        modalData: { text, sent_by, rating },
      }
    })
  }

  useEffect(() => {
  if (!textRef.current) return;

  const observer = new ResizeObserver(() => {
    if (!textRef.current) return;
    const isOver = textRef.current.scrollHeight > textRef.current.clientHeight;
    setIsOverflowing(isOver);
  });

  observer.observe(textRef.current);

  return () => observer.disconnect();
}, []);

  return (
    <div className={styles.textWrapper}>
      <div
        ref={textRef}
        className={`${styles.text} ${!showMore ? styles.collapsed : ''}`}
      >
        {`${text}`}
      </div>
      {isOverflowing && (
        <button id={`testimonial-btn-${Id}`} className={styles.button} onClick={() => handleTestimonial()}>
          {showMore ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
};

const TestimonialsPage = ({ testimonials, isLandingPage = false, isStudentStory = false }) => {
  return (() =>
     {
    if (!testimonials || testimonials.length === 0) return null;
  
    if (testimonials.length === 1) {
      const item = testimonials[0];
      return (
        <div className={`${styles.root} ${styles.singleWrapper}`}>
          <div className={styles.card}>
            <div className={styles.header}>
              <img
                src={
                  item?.sent_by?.avatar ||
                  'https://static.amityonline.com/_s/avatar_nerd_man_vector_42477860_removebg_preview_68cec19df4_d0073b7893.webp'
                }
                alt={item?.sent_by?.name}
                className={styles.avatar}
                loading="lazy"
              />
              <div className={styles.nameDiv}>
                <div className={styles.name}>{item?.sent_by?.name}</div>
                {item?.sent_by?.title && <div className={styles.title}>{item.sent_by.title}</div>}
              </div>
            </div>
            <div className={styles.stars}>
              {Array.from({ length: 5 }).map((_, i) => (
                <span key={i}>{i < item?.rating ? '★' : '☆'}</span>
              ))}
            </div>
            <TestimonialText {...item} />
          </div>
        </div>
      );
    }
  
    return (
      <div className={cn(styles.root, { [styles.container]: isLandingPage })}>
        <div className={cn({ [styles.innerContainer]: isLandingPage })}>
          <Carousel
            config={{
              spaceBetween: 20,
              slidesPerView: 1,
              pagination: {
                status: true,
                className: `${isStudentStory ? 'student_review_carousel_pagination text-center' : ''} my-4`
              },
              breakpoints: {
                320: {
                  slidesPerView: 1
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                1600: {
                  slidesPerView: 3,
                  spaceBetween: 20
                }
              }
            }}
            className={styles.testimonial_student_carousel}
            id="texttestimonial"
          >
            {testimonials.map((item, index) => (
              <div className={styles.card} key={index}>
                <div className={styles.header}>
                  <img
                    src={
                      item?.sent_by?.avatar ||
                      'https://static.amityonline.com/_s/avatar_nerd_man_vector_42477860_removebg_preview_68cec19df4_d0073b7893.webp'
                    }
                    alt={item?.sent_by?.name}
                    className={styles.avatar}
                    loading="lazy"
                  />
                  <div className={styles.nameDiv}>
                    <div className={styles.name}>{item?.sent_by?.name}</div>
                    {item?.sent_by?.title && <div className={styles.title}>{item.sent_by.title}</div>}
                  </div>
                </div>
                <div className={styles.stars}>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i}>{i < item?.rating ? '★' : '☆'}</span>
                  ))}
                </div>
                <TestimonialText {...item} Id={String(index)} />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    );
  })();  

};


        export default TestimonialsPage;
